export default __webpack_public_path__ + "static/media/interview-buddy.3f277c6f.png";